module.exports = __webpack_public_path__ + "img/more.c07fc582.png";